import { TDatasetName } from '@infotech-soe/metaschema';

import DatasetTreeNode from './DatasetTreeNode';
import DatasetTreeNodeVisitor from './DatasetTreeNodeVisitor';

/**
 * A logical dataset tree element that corresponds to a dataset of a
 * display mode.
 */
class DisplayModeDatasetTreeNode extends DatasetTreeNode {
  /**
   * @param datasetName - Name of the dataset in display mode schema.
   */
  constructor(private datasetName: TDatasetName) {
    super();
  }

  /**
   * Returns the associated name of the dataset in display mode schema.
   */
  public getDatasetName(): TDatasetName {
    return this.datasetName;
  }

  public acceptVisitor(visitor: DatasetTreeNodeVisitor): void {
    visitor.visitDisplayModeDataset(this);
  }
}

export default DisplayModeDatasetTreeNode;
